import { render, staticRenderFns } from "./icaseFrom.vue?vue&type=template&id=57ff1ad6&scoped=true"
import script from "./icaseFrom.vue?vue&type=script&lang=js"
export * from "./icaseFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff1ad6",
  null
  
)

export default component.exports